import classNames from "classnames";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
// import { Rating } from "react-simple-star-rating";
import Select from "react-select";
// import Tippy from "@tippyjs/react";
import { ReactBingmaps } from "react-bingmaps";
import { ModalConfirm } from "tamtam-components";

import Switch from "../../../common/Switch/Switch";
import { DragHandle } from "../MyPortals";
import styles from "./Portals.module.scss";
import _ from "../../../../i18n";
import Category from "../../Category";
import { SELECT_STYLES } from "../../../../config";
import Tabs from "../../../common/Tabs";

import Button from "../../../common/Button";
import Loader from "../../../common/Loader";
import MediaList from "../../MediaList";
import CollaboratorsSortableList from "../../CollaboratorsSortableList";
import FormInput from "../../../common/FormInput";

import TimeInput from "../../../common/TimeInput";

import { IconStar } from "../../../common/icons/IconStar";

import WatchSharing from "../WatchSharing";
// import IconInfo from "../../../common/icons/IconInfo";
import NewsletterModal from "../../../common/NewsletterModal";
import ServicePopOver from "../../ServicePopOver";
import MediaPopOver from "../../MediaPopOver";
import ServicesSortableList from "../../ServicesSortableList";
import { deleteService } from "../../../../api";
import FaqModal from "../../FaqModal";
import FaqsSortableList from "../../FaqsSortableList";
import { deleteFaq } from "../../../../api/faq";
import { deleteTestimonial } from "../../../../api/testimonial";
import TestimonialModal from "../../TestimonialModal";
import TestimonialsSortableList from "../../TestimonialsSortableList";
import { validateEmail, validatePhone } from "../../../../utils";
import Service from "../../ServicesSortableList/Service";
import AddSingleMedia from "../../../common/AddSingleMedia";

const languages = [
  { value: "fr", label: _("french") },
  { value: "en", label: _("english") },
  { value: "nl", label: _("dutch") },
];

const days = ["MON", "TUE", "WED", "TUR", "FRI", "SAT", "SUN"];

export const DefaultApp = ({ value, handleCheckApp, type }) => {
  return (
    <li className={classNames(styles.appsItem, styles.appsItem_header)}>
      <div className={styles.appsItem_top}>
        <DragHandle />
        <img src={`img/apps/${value.icon}`} alt="" />
        {value.name}
      </div>
      <Switch
        isChecked={value.enabled}
        onChange={(e) => handleCheckApp(type, e, value)}
      />
    </li>
  );
};

export const WatchApp = ({ value, handleCheckApp, type }) => {
  const [showModal, setShowModal] = useState(false);
  return (
    <li className={classNames(styles.appsItem, styles.appsItem_header)}>
      <div className={styles.appsItem_topwatch}>
        <div className={styles.appsItem_top}>
          <DragHandle />
          <img src={`img/apps/${value.icon}`} alt="" />
          <span className={styles.watch}>
            <span>{value.name}</span>
            <span>
              <span className={styles.watch_tag}>WATCH</span>
            </span>
          </span>
        </div>
        <span className={styles.watch_link} onClick={() => setShowModal(true)}>
          {_("manage_premium_sharing")}
        </span>
      </div>

      <Switch
        isChecked={value.enabled}
        onChange={(e) => handleCheckApp(type, e, value)}
      />
      <WatchSharing showModal={showModal} setShowModal={setShowModal} />
    </li>
  );
};

export const BlogApp = ({
  value,
  handleCheckApp,
  type,
  portals,
  setPortals,
  handleScopeChange,
  scopeFilter,
  setScopeFilter,
  categoryFilter,
  setCategoryFilter,
  initCategoryFilter,
  authorTypes,
  authorTypesFilter,
  setAuthorTypesFilter,
}) => {
  const lng = useSelector((state) => state.params.language);
  return (
    <li className={styles.appsItem}>
      <div className={styles.appsItem_header}>
        <div className={styles.appsItem_left}>
          <div className={styles.appsItem_top}>
            <DragHandle />
            <img src={`img/apps/${value.icon}`} alt="" />
            {value.name}
          </div>
          <Switch
            isChecked={value.enabled}
            onChange={(e) => handleCheckApp(type, e, value)}
          />
        </div>
        <div className={styles.appsItem_right}>
          <i
            className={
              value.enabled ? "icon-ttp-chevron-up" : "icon-ttp-chevron-down"
            }
          />
        </div>
      </div>
      {value.enabled && (
        <div className={styles.appsItem_content}>
          {/*<div className={`grid-x ${styles.switchGroup}`}>
            <div
              className={classNames(styles.filter, "cell small-12 medium-4")}
            >
              <label className={styles.configLabel}>{_("article_feed")}</label>
              <ul className={styles.switches}>
                <li>
                  <div
                    className={classNames(
                      styles.checkbox,
                      portals[type].config.apps.filter(
                        (el) => el.value === value.value
                      )[0].type === "BOTH"
                        ? styles.checkbox_active
                        : ""
                    )}
                    onClick={() => {
                      const tab = portals[type].config.apps.map((app) => {
                        if (app.value === value.value) {
                          app.type = "BOTH";
                        }
                        return app;
                      });
                      setPortals({
                        ...portals,
                        [type]: {
                          ...portals[type],
                          config: {
                            ...portals[type].config,
                            apps: tab,
                          },
                        },
                      });
                    }}
                  >
                    {portals[type].config.apps.filter(
                      (el) => el.value === value.value
                    )[0].type === "BOTH" && (
                      <svg
                        width="10"
                        height="10"
                        viewBox="0 0 10 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_49976_35660)">
                          <path
                            d="M3.95836 9.44352C3.68037 9.44352 3.41746 9.31425 3.24844 9.09253L0.965733 6.09609C0.668833 5.70637 0.746124 5.15145 1.1382 4.85621C1.53092 4.56085 2.08882 4.63818 2.38584 5.02764L3.88721 6.99818L7.66322 0.971768C7.9232 0.557165 8.47216 0.430308 8.89017 0.68834C9.30767 0.946626 9.43517 1.49266 9.17506 1.90764L4.71441 9.02637C4.55945 9.27386 4.29193 9.42955 3.99899 9.44275C3.98532 9.44326 3.97191 9.44352 3.95836 9.44352Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_49976_35660">
                            <rect
                              width="8.94276"
                              height="8.88889"
                              fill="white"
                              transform="translate(0.576172 0.554688)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    )}
                  </div>
                  <span>{_("both")}</span>
                </li>
                <li>
                  <div
                    className={classNames(
                      styles.checkbox,
                      portals[type].config.apps.filter(
                        (el) => el.value === value.value
                      )[0].type === "MINE"
                        ? styles.checkbox_active
                        : ""
                    )}
                    onClick={() => {
                      const tab = portals[type].config.apps.map((app) => {
                        if (app.value === value.value) {
                          app.type = "MINE";
                        }
                        return app;
                      });
                      setPortals({
                        ...portals,
                        [type]: {
                          ...portals[type],
                          config: {
                            ...portals[type].config,
                            apps: tab,
                          },
                        },
                      });
                    }}
                  >
                    {portals[type].config.apps.filter(
                      (el) => el.value === value.value
                    )[0].type === "MINE" && (
                      <svg
                        width="10"
                        height="10"
                        viewBox="0 0 10 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_49976_35660)">
                          <path
                            d="M3.95836 9.44352C3.68037 9.44352 3.41746 9.31425 3.24844 9.09253L0.965733 6.09609C0.668833 5.70637 0.746124 5.15145 1.1382 4.85621C1.53092 4.56085 2.08882 4.63818 2.38584 5.02764L3.88721 6.99818L7.66322 0.971768C7.9232 0.557165 8.47216 0.430308 8.89017 0.68834C9.30767 0.946626 9.43517 1.49266 9.17506 1.90764L4.71441 9.02637C4.55945 9.27386 4.29193 9.42955 3.99899 9.44275C3.98532 9.44326 3.97191 9.44352 3.95836 9.44352Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_49976_35660">
                            <rect
                              width="8.94276"
                              height="8.88889"
                              fill="white"
                              transform="translate(0.576172 0.554688)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    )}
                  </div>
                  <span>{_("my_articles")}</span>
                </li>
                <li>
                  <div
                    className={classNames(
                      styles.checkbox,
                      portals[type].config.apps.filter(
                        (el) => el.value === value.value
                      )[0].type === "FFF"
                        ? styles.checkbox_active
                        : ""
                    )}
                    onClick={() => {
                      const tab = portals[type].config.apps.map((app) => {
                        if (app.value === value.value) {
                          app.type = "FFF";
                        }
                        return app;
                      });
                      setPortals({
                        ...portals,
                        [type]: {
                          ...portals[type],
                          config: {
                            ...portals[type].config,
                            apps: tab,
                          },
                        },
                      });
                    }}
                  >
                    {portals[type].config.apps.filter(
                      (el) => el.value === value.value
                    )[0].type === "FFF" && (
                      <svg
                        width="10"
                        height="10"
                        viewBox="0 0 10 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_49976_35660)">
                          <path
                            d="M3.95836 9.44352C3.68037 9.44352 3.41746 9.31425 3.24844 9.09253L0.965733 6.09609C0.668833 5.70637 0.746124 5.15145 1.1382 4.85621C1.53092 4.56085 2.08882 4.63818 2.38584 5.02764L3.88721 6.99818L7.66322 0.971768C7.9232 0.557165 8.47216 0.430308 8.89017 0.68834C9.30767 0.946626 9.43517 1.49266 9.17506 1.90764L4.71441 9.02637C4.55945 9.27386 4.29193 9.42955 3.99899 9.44275C3.98532 9.44326 3.97191 9.44352 3.95836 9.44352Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_49976_35660">
                            <rect
                              width="8.94276"
                              height="8.88889"
                              fill="white"
                              transform="translate(0.576172 0.554688)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    )}
                  </div>
                  <span>{_("fff_articles")}</span>
                </li>
              </ul>
            </div>
            <div
              className={classNames(styles.filter, "cell small-12 medium-4")}
            >
              <label className={styles.configLabel}>{_("Scope")}</label>
              <ul className={styles.switches}>
                <li>
                  <div
                    className={classNames(
                      styles.checkbox,
                      scopeFilter.includes("PUBLIC")
                        ? styles.checkbox_active
                        : ""
                    )}
                    onClick={() => {
                      handleScopeChange(
                        "PUBLIC",
                        !scopeFilter.includes("PUBLIC"),
                        scopeFilter,
                        setScopeFilter
                      );
                    }}
                  >
                    {scopeFilter.includes("PUBLIC") && (
                      <svg
                        width="10"
                        height="10"
                        viewBox="0 0 10 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_49976_35660)">
                          <path
                            d="M3.95836 9.44352C3.68037 9.44352 3.41746 9.31425 3.24844 9.09253L0.965733 6.09609C0.668833 5.70637 0.746124 5.15145 1.1382 4.85621C1.53092 4.56085 2.08882 4.63818 2.38584 5.02764L3.88721 6.99818L7.66322 0.971768C7.9232 0.557165 8.47216 0.430308 8.89017 0.68834C9.30767 0.946626 9.43517 1.49266 9.17506 1.90764L4.71441 9.02637C4.55945 9.27386 4.29193 9.42955 3.99899 9.44275C3.98532 9.44326 3.97191 9.44352 3.95836 9.44352Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_49976_35660">
                            <rect
                              width="8.94276"
                              height="8.88889"
                              fill="white"
                              transform="translate(0.576172 0.554688)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    )}
                  </div>
                  <span>{_("all")}</span>
                </li>
                <li>
                  <div
                    className={classNames(
                      styles.checkbox,
                      scopeFilter.includes("CLIENT")
                        ? styles.checkbox_active
                        : ""
                    )}
                    onClick={() => {
                      handleScopeChange(
                        "CLIENT",
                        !scopeFilter.includes("CLIENT"),
                        scopeFilter,
                        setScopeFilter
                      );
                    }}
                  >
                    {scopeFilter.includes("CLIENT") && (
                      <svg
                        width="10"
                        height="10"
                        viewBox="0 0 10 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_49976_35660)">
                          <path
                            d="M3.95836 9.44352C3.68037 9.44352 3.41746 9.31425 3.24844 9.09253L0.965733 6.09609C0.668833 5.70637 0.746124 5.15145 1.1382 4.85621C1.53092 4.56085 2.08882 4.63818 2.38584 5.02764L3.88721 6.99818L7.66322 0.971768C7.9232 0.557165 8.47216 0.430308 8.89017 0.68834C9.30767 0.946626 9.43517 1.49266 9.17506 1.90764L4.71441 9.02637C4.55945 9.27386 4.29193 9.42955 3.99899 9.44275C3.98532 9.44326 3.97191 9.44352 3.95836 9.44352Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_49976_35660">
                            <rect
                              width="8.94276"
                              height="8.88889"
                              fill="white"
                              transform="translate(0.576172 0.554688)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    )}
                  </div>
                  <span>{_("Clients")}</span>
                </li>
                <li>
                  <div
                    className={classNames(
                      styles.checkbox,
                      scopeFilter.includes("COLLABORATOR")
                        ? styles.checkbox_active
                        : ""
                    )}
                    onClick={() => {
                      handleScopeChange(
                        "COLLABORATOR",
                        !scopeFilter.includes("COLLABORATOR"),
                        scopeFilter,
                        setScopeFilter
                      );
                    }}
                  >
                    {scopeFilter.includes("COLLABORATOR") && (
                      <svg
                        width="10"
                        height="10"
                        viewBox="0 0 10 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_49976_35660)">
                          <path
                            d="M3.95836 9.44352C3.68037 9.44352 3.41746 9.31425 3.24844 9.09253L0.965733 6.09609C0.668833 5.70637 0.746124 5.15145 1.1382 4.85621C1.53092 4.56085 2.08882 4.63818 2.38584 5.02764L3.88721 6.99818L7.66322 0.971768C7.9232 0.557165 8.47216 0.430308 8.89017 0.68834C9.30767 0.946626 9.43517 1.49266 9.17506 1.90764L4.71441 9.02637C4.55945 9.27386 4.29193 9.42955 3.99899 9.44275C3.98532 9.44326 3.97191 9.44352 3.95836 9.44352Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_49976_35660">
                            <rect
                              width="8.94276"
                              height="8.88889"
                              fill="white"
                              transform="translate(0.576172 0.554688)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    )}
                  </div>
                  <span>{_("Collaborators")}</span>
                </li>
              </ul>
            </div>
            <div
              className={classNames(styles.filter, "cell small-12 medium-4")}
              style={{ border: "none" }}
            >
              <label className={styles.configLabel}>{_("relevance")}</label>
              <div>
                <Rating
                  onClick={(e) => {
                    const tab = portals[type].config.apps.map((app) => {
                      if (app.value === value.value) {
                        app.relevance = e / 20;
                      }
                      return app;
                    });
                    setPortals({
                      ...portals,
                      [type]: {
                        ...portals[type],
                        config: {
                          ...portals[type].config,
                          apps: tab,
                        },
                      },
                    });
                  }}
                  ratingValue={
                    portals[type].config.apps.filter(
                      (el) => el.value === value.value
                    )[0].relevance * 20
                  }
                  size={22}
                  fillColor="#18a0fb"
                />
              </div>
            </div>
                </div>*/}

          <div className={`grid-x grid-margin-x`}>
            <div className="cell small-12 medium-6">
              <label className={styles.config_Label}>{_("category")}</label>
              <Category
                language={lng}
                category={categoryFilter}
                setCategory={setCategoryFilter}
                initialCategories={initCategoryFilter}
              />
            </div>
            <div className="cell small-12 medium-6">
              <label className={styles.config_Label}>{_("author_type")}</label>
              <Select
                styles={SELECT_STYLES}
                options={authorTypes}
                placeholder={_("select_type")}
                value={authorTypesFilter}
                onChange={(e) => setAuthorTypesFilter(e)}
                isMulti
                noOptionsMessage={() => _(`no_options`)}
              />
            </div>
          </div>
        </div>
      )}
    </li>
  );
};

export const BlogAppPublic = ({
  handlePortalBlocChange,
  portals,
  setPortals,
  handleScopeChange,
  scopeFilter,
  categoryFilter,
  setCategoryFilter,
  initCategoryFilter,
  authorTypes,
  authorTypeFilter,
  setAuthorTypeFilter,
  titleAttr,
  handlePortalBlocTitleChange,
  descriptionAttr,
  handlePortalBlocDescriptionChange,
}) => {
  const lng = useSelector((state) => state.params.language);
  return (
    <div className={styles.portalBloc}>
      <div className={styles.portalBloc_top}>
        <div className={styles.portalBloc_top_left}>
          <img src={`img/apps/blog.svg`} alt="" />
          <label>{_("News")}</label>
        </div>
        <Switch
          isChecked={portals.public.config.news.activated}
          onChange={(e) => handlePortalBlocChange(e, "news")}
        />
      </div>
      {portals.public.config.news.activated && (
        <>
          {/* <div className={`grid-x ${styles.switchGroup}`}>
            <div
              className={classNames(styles.filter, "cell small-12 medium-4")}
            >
              <div className={styles.configLabel_cont}>
                <label className={styles.configLabel}>
                  {_("article_feed")}
                </label>
                <Tippy content={<span>{_("article_feed_tooltip")}</span>}>
                  <span className={styles.tooltip}>
                    <IconInfo />
                  </span>
                </Tippy>
              </div>
              <ul className={styles.switches}>
                <li>
                  <div
                    className={classNames(
                      styles.checkbox,
                      portals.public.config.news.type === "BOTH"
                        ? styles.checkbox_active
                        : ""
                    )}
                    onClick={() => {
                      setPortals({
                        ...portals,
                        public: {
                          ...portals.public,
                          config: {
                            ...portals.public.config,
                            news: {
                              ...portals.public.config.news,
                              type: "BOTH",
                            },
                          },
                        },
                      });
                    }}
                  >
                    {portals.public.config.news.type === "BOTH" && (
                      <svg
                        width="10"
                        height="10"
                        viewBox="0 0 10 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_49976_35660)">
                          <path
                            d="M3.95836 9.44352C3.68037 9.44352 3.41746 9.31425 3.24844 9.09253L0.965733 6.09609C0.668833 5.70637 0.746124 5.15145 1.1382 4.85621C1.53092 4.56085 2.08882 4.63818 2.38584 5.02764L3.88721 6.99818L7.66322 0.971768C7.9232 0.557165 8.47216 0.430308 8.89017 0.68834C9.30767 0.946626 9.43517 1.49266 9.17506 1.90764L4.71441 9.02637C4.55945 9.27386 4.29193 9.42955 3.99899 9.44275C3.98532 9.44326 3.97191 9.44352 3.95836 9.44352Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_49976_35660">
                            <rect
                              width="8.94276"
                              height="8.88889"
                              fill="white"
                              transform="translate(0.576172 0.554688)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    )}
                  </div>
                  <span>{_("both")}</span>
                </li>
                <li>
                  <div
                    className={classNames(
                      styles.checkbox,
                      portals.public.config.news.type === "MINE"
                        ? styles.checkbox_active
                        : ""
                    )}
                    onClick={() => {
                      setPortals({
                        ...portals,
                        public: {
                          ...portals.public,
                          config: {
                            ...portals.public.config,
                            news: {
                              ...portals.public.config.news,
                              type: "MINE",
                            },
                          },
                        },
                      });
                    }}
                  >
                    {portals.public.config.news.type === "MINE" && (
                      <svg
                        width="10"
                        height="10"
                        viewBox="0 0 10 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_49976_35660)">
                          <path
                            d="M3.95836 9.44352C3.68037 9.44352 3.41746 9.31425 3.24844 9.09253L0.965733 6.09609C0.668833 5.70637 0.746124 5.15145 1.1382 4.85621C1.53092 4.56085 2.08882 4.63818 2.38584 5.02764L3.88721 6.99818L7.66322 0.971768C7.9232 0.557165 8.47216 0.430308 8.89017 0.68834C9.30767 0.946626 9.43517 1.49266 9.17506 1.90764L4.71441 9.02637C4.55945 9.27386 4.29193 9.42955 3.99899 9.44275C3.98532 9.44326 3.97191 9.44352 3.95836 9.44352Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_49976_35660">
                            <rect
                              width="8.94276"
                              height="8.88889"
                              fill="white"
                              transform="translate(0.576172 0.554688)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    )}
                  </div>
                  <span>{_("my_articles")}</span>
                </li>
                <li>
                  <div
                    className={classNames(
                      styles.checkbox,
                      portals.public.config.news.type === "FFF"
                        ? styles.checkbox_active
                        : ""
                    )}
                    onClick={() => {
                      setPortals({
                        ...portals,
                        public: {
                          ...portals.public,
                          config: {
                            ...portals.public.config,
                            news: {
                              ...portals.public.config.news,
                              type: "FFF",
                            },
                          },
                        },
                      });
                    }}
                  >
                    {portals.public.config.news.type === "FFF" && (
                      <svg
                        width="10"
                        height="10"
                        viewBox="0 0 10 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_49976_35660)">
                          <path
                            d="M3.95836 9.44352C3.68037 9.44352 3.41746 9.31425 3.24844 9.09253L0.965733 6.09609C0.668833 5.70637 0.746124 5.15145 1.1382 4.85621C1.53092 4.56085 2.08882 4.63818 2.38584 5.02764L3.88721 6.99818L7.66322 0.971768C7.9232 0.557165 8.47216 0.430308 8.89017 0.68834C9.30767 0.946626 9.43517 1.49266 9.17506 1.90764L4.71441 9.02637C4.55945 9.27386 4.29193 9.42955 3.99899 9.44275C3.98532 9.44326 3.97191 9.44352 3.95836 9.44352Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_49976_35660">
                            <rect
                              width="8.94276"
                              height="8.88889"
                              fill="white"
                              transform="translate(0.576172 0.554688)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    )}
                  </div>
                  <span>{_("fff_articles")}</span>
                </li>
              </ul>
            </div>
            <div
              className={classNames(styles.filter, "cell small-12 medium-4")}
            >
              <div className={styles.configLabel_cont}>
                <label className={styles.configLabel}>{_("scope")}</label>
                <Tippy content={<span>{_("scope_tooltip")}</span>}>
                  <span className={styles.tooltip}>
                    <IconInfo />
                  </span>
                </Tippy>
              </div>

              <ul className={styles.switches}>
                <li>
                  <div
                    className={classNames(
                      styles.checkbox,
                      scopeFilter.includes("PUBLIC")
                        ? styles.checkbox_active
                        : ""
                    )}
                    onClick={() => {
                      handleScopeChange(
                        "PUBLIC",
                        !scopeFilter.includes("PUBLIC")
                      );
                    }}
                  >
                    {scopeFilter.includes("PUBLIC") && (
                      <svg
                        width="10"
                        height="10"
                        viewBox="0 0 10 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_49976_35660)">
                          <path
                            d="M3.95836 9.44352C3.68037 9.44352 3.41746 9.31425 3.24844 9.09253L0.965733 6.09609C0.668833 5.70637 0.746124 5.15145 1.1382 4.85621C1.53092 4.56085 2.08882 4.63818 2.38584 5.02764L3.88721 6.99818L7.66322 0.971768C7.9232 0.557165 8.47216 0.430308 8.89017 0.68834C9.30767 0.946626 9.43517 1.49266 9.17506 1.90764L4.71441 9.02637C4.55945 9.27386 4.29193 9.42955 3.99899 9.44275C3.98532 9.44326 3.97191 9.44352 3.95836 9.44352Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_49976_35660">
                            <rect
                              width="8.94276"
                              height="8.88889"
                              fill="white"
                              transform="translate(0.576172 0.554688)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    )}
                  </div>
                  <span>{_("all")}</span>
                </li>
                <li>
                  <div
                    className={classNames(
                      styles.checkbox,
                      scopeFilter.includes("CLIENT")
                        ? styles.checkbox_active
                        : ""
                    )}
                    onClick={() => {
                      handleScopeChange(
                        "CLIENT",
                        !scopeFilter.includes("CLIENT")
                      );
                    }}
                  >
                    {scopeFilter.includes("CLIENT") && (
                      <svg
                        width="10"
                        height="10"
                        viewBox="0 0 10 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_49976_35660)">
                          <path
                            d="M3.95836 9.44352C3.68037 9.44352 3.41746 9.31425 3.24844 9.09253L0.965733 6.09609C0.668833 5.70637 0.746124 5.15145 1.1382 4.85621C1.53092 4.56085 2.08882 4.63818 2.38584 5.02764L3.88721 6.99818L7.66322 0.971768C7.9232 0.557165 8.47216 0.430308 8.89017 0.68834C9.30767 0.946626 9.43517 1.49266 9.17506 1.90764L4.71441 9.02637C4.55945 9.27386 4.29193 9.42955 3.99899 9.44275C3.98532 9.44326 3.97191 9.44352 3.95836 9.44352Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_49976_35660">
                            <rect
                              width="8.94276"
                              height="8.88889"
                              fill="white"
                              transform="translate(0.576172 0.554688)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    )}
                  </div>
                  <span>{_("clients")}</span>
                </li>
                <li>
                  <div
                    className={classNames(
                      styles.checkbox,
                      scopeFilter.includes("COLLABORATOR")
                        ? styles.checkbox_active
                        : ""
                    )}
                    onClick={() => {
                      handleScopeChange(
                        "COLLABORATOR",
                        !scopeFilter.includes("COLLABORATOR")
                      );
                    }}
                  >
                    {scopeFilter.includes("COLLABORATOR") && (
                      <svg
                        width="10"
                        height="10"
                        viewBox="0 0 10 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_49976_35660)">
                          <path
                            d="M3.95836 9.44352C3.68037 9.44352 3.41746 9.31425 3.24844 9.09253L0.965733 6.09609C0.668833 5.70637 0.746124 5.15145 1.1382 4.85621C1.53092 4.56085 2.08882 4.63818 2.38584 5.02764L3.88721 6.99818L7.66322 0.971768C7.9232 0.557165 8.47216 0.430308 8.89017 0.68834C9.30767 0.946626 9.43517 1.49266 9.17506 1.90764L4.71441 9.02637C4.55945 9.27386 4.29193 9.42955 3.99899 9.44275C3.98532 9.44326 3.97191 9.44352 3.95836 9.44352Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_49976_35660">
                            <rect
                              width="8.94276"
                              height="8.88889"
                              fill="white"
                              transform="translate(0.576172 0.554688)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    )}
                  </div>
                  <span>{_("collaborators")}</span>
                </li>
              </ul>
            </div>
            <div
              className={classNames(styles.filter, "cell small-12 medium-4")}
              style={{ border: "none" }}
            >
              <div className={styles.configLabel_cont}>
                <label className={styles.configLabel}>{_("relevance")}</label>
                <Tippy content={<span>{_("relevance_tooltip")}</span>}>
                  <span className={styles.tooltip}>
                    <IconInfo />
                  </span>
                </Tippy>
              </div>

              <div>
                <Rating
                  onClick={(e) => {
                    setPortals({
                      ...portals,
                      public: {
                        ...portals.public,
                        config: {
                          ...portals.public.config,
                          news: {
                            ...portals.public.config.news,
                            relevance: e / 20,
                          },
                        },
                      },
                    });
                  }}
                  ratingValue={portals.public.config.news.relevance * 20}
                  size={22}
                  fillColor="#18a0fb"
                />
              </div>
            </div>
          </div>

          <div className={styles.newsFilter}>
            <div className={`grid-x grid-margin-x ${styles.formRow}`}>
              <div className="cell small-12 medium-6">
                <label className={styles.configLabel}>{_("category")}</label>
                <Category
                  language={lng}
                  category={categoryFilter}
                  setCategory={setCategoryFilter}
                  initialCategories={initCategoryFilter}
                />
              </div>
              <div className="cell small-12 medium-6">
                <label className={styles.configLabel}>
                  {_("author_type")}
                </label>

                <Select
                  styles={SELECT_STYLES}
                  options={authorTypes}
                  placeholder={_("select_type")}
                  value={authorTypeFilter}
                  onChange={(e) => setAuthorTypeFilter(e)}
                  isMulti
                  noOptionsMessage={() => _(`no_options`)}
                />
              </div>
            </div>
          </div> */}

          <Tabs theme="wtheme">
            {languages.map((language) => (
              <div
                key={`langtab${language.value}`}
                label={language.label}
                icon={`https://tamtam.s3-eu-west-1.amazonaws.com/cdn/img/flags/${language.value}.png`}
              >
                <div className={styles.langTab}>
                  <label className={styles.configLabel}>
                    {_(`title_${language.value}`)}
                  </label>

                  <input
                    className={styles.formInput}
                    value={
                      portals.public.config.news[titleAttr(language.value)]
                    }
                    onChange={(e) =>
                      handlePortalBlocTitleChange(
                        language.value,
                        e.target.value,
                        "news"
                      )
                    }
                  />

                  <label
                    className={`${styles.configLabel} ${styles.descriptionLabel}`}
                  >
                    {_(`description_${language.value}`)}
                  </label>
                  <textarea
                    rows="4"
                    className={styles.descriptionInput}
                    value={
                      portals.public.config.news[
                        descriptionAttr(language.value)
                      ]
                    }
                    onChange={(e) =>
                      handlePortalBlocDescriptionChange(
                        language.value,
                        e.target.value,
                        "news"
                      )
                    }
                  />
                </div>
              </div>
            ))}
          </Tabs>
        </>
      )}
    </div>
  );
};

export const MediaAppPublic = ({
  handlePortalBlocChange,
  portals,
  setAddMediaModalOpened,
  fetchingMedia,
  medias,
  setMedias,
  descriptionAttr,
  handlePortalBlocDescriptionChange,
}) => {
  const lng = useSelector((state) => state.params.language);
  return (
    <div className={styles.portalBloc}>
      <div className={styles.portalBloc_top}>
        <div className={styles.portalBloc_top_left}>
          <img src={`img/apps/media.svg`} alt="" />
          <label>{_("carousel")}</label>
        </div>
        <Switch
          isChecked={portals.public.config.media.activated}
          onChange={(e) => handlePortalBlocChange(e, "media")}
        />
      </div>
      {portals.public.config.media.activated && (
        <>
          <Tabs theme="wtheme">
            {languages.map((language) => (
              <div
                key={`langtab${language.value}`}
                label={language.label}
                icon={`https://tamtam.s3-eu-west-1.amazonaws.com/cdn/img/flags/${language.value}.png`}
              >
                <div className={styles.langTab}>
                  <label
                    className={`${styles.configLabel} ${styles.descriptionLabel}`}
                  >
                    {_(`description_${language.value}`)}
                  </label>
                  <textarea
                    rows="4"
                    className={styles.descriptionInput}
                    value={
                      portals.public.config.media[
                        descriptionAttr(language.value)
                      ]
                    }
                    onChange={(e) =>
                      handlePortalBlocDescriptionChange(
                        language.value,
                        e.target.value,
                        "media"
                      )
                    }
                  />
                </div>
              </div>
            ))}
          </Tabs>

          <p className={styles.mediaTitle}>
            Choississez les images que vous désirez voir apparaitre dans votre
            bannière.
          </p>

          <Button
            className={styles.addMedia}
            size={"sm"}
            onClick={() => setAddMediaModalOpened(true)}
          >
            {_("add_media")}
          </Button>
          {fetchingMedia ? (
            <Loader
              color={"#18a0fb"}
              style={{
                width: "100%",
                height: "0.5rem",
                margin: "1rem auto",
              }}
            />
          ) : (
            <MediaList
              medias={medias}
              setMedias={setMedias}
              language={lng}
              isUsed={true}
            />
          )}
        </>
      )}
    </div>
  );
};

export const MemberMediaAppPublic = ({
  handlePortalBlocChange,
  portals,
  medias,
  setMedias,
  maxPicks = 3,
}) => {
  const [openMediaModal, setOpenMediaModal] = useState(false);
  const [currentMedia, setCurrentMedia] = useState(false);

  const allowAdd = () => {
    if (maxPicks === -1) {
      return true;
    }
    return !(maxPicks < medias.length + 1);
  };

  const afterMediaSave = (val) => {
    if (medias.map((el) => el.id).includes(val.id)) {
      setMedias(
        medias.map((el) => {
          if (el.id === val.id) {
            return val;
          }
          return el;
        })
      );
    } else {
      setMedias([val, ...medias]);
    }
    setOpenMediaModal(false);
  };

  const onDelete = (val) => {
    setMedias(medias.filter((el) => el.id !== val.id));
  };

  const onEdit = (val) => {
    setCurrentMedia(medias.filter((el) => el.id === val.id)[0]);
    setOpenMediaModal(true);
  };

  return (
    <div className={styles.portalBloc}>
      <div className={styles.portalBloc_top}>
        <div className={styles.portalBloc_top_left}>
          <img src={`img/apps/media.svg`} alt="" />
          <label>{_("carousel")}</label>
        </div>
        <Switch
          isChecked={portals.public.config.memberMedia.activated}
          onChange={(e) => handlePortalBlocChange(e, "memberMedia")}
        />
      </div>
      {portals.public.config.memberMedia.activated && (
        <>
          <p className={styles.mediaTitle}>
            Choississez les images que vous désirez voir apparaitre dans votre
            bannière.
          </p>
          <Button
            className={styles.addMedia}
            size={"sm"}
            onClick={() => {
              if (allowAdd()) {
                setOpenMediaModal(true);
              }
            }}
          >
            {_("add_media")}
          </Button>

          {medias.length > 0 && (
            <div className={classNames(styles.mediasList, "grid-x")}>
              {medias.map((media) => (
                <div
                  key={media.id}
                  className={classNames(
                    styles.mediaCont,
                    "cell small-12 medium-6 large-4"
                  )}
                >
                  <Service
                    service={{
                      ...media,
                      image: media.image.fullMediaUrl,
                    }}
                    onDelete={onDelete}
                    onEdit={onEdit}
                    onHide={null}
                  />
                </div>
              ))}
            </div>
          )}

          <MediaPopOver
            languages={languages}
            isOpen={openMediaModal}
            onClose={() => setOpenMediaModal(false)}
            afterMediaSave={afterMediaSave}
            currentElement={currentMedia}
            setCurrentElement={setCurrentMedia}
          />
        </>
      )}
    </div>
  );
};

export const AboutAppPublic = ({
  handlePortalBlocChange,
  portals,
  aboutImage,
  setAboutImage,
  titleAttr,
  handlePortalBlocTitleChange,
  descriptionAttr,
  handlePortalBlocDescriptionChange,
}) => {
  const auth = useSelector((state) => state.auth);
  const fiduciary = useSelector((state) => state.folder.fiduciary);
  const [addMediaModalOpened, setAddMediaModalOpened] = useState(false);

  return (
    <div className={styles.portalBloc}>
      <div className={styles.portalBloc_top}>
        <div className={styles.portalBloc_top_left}>
          <label>{_("about")}</label>
        </div>
        <Switch
          isChecked={portals.public.config.about.activated}
          onChange={(e) => handlePortalBlocChange(e, "about")}
        />
      </div>
      {portals.public.config.about.activated && (
        <>
          <Tabs theme="wtheme">
            {languages.map((language) => (
              <div
                key={`langtab${language.value}`}
                label={language.label}
                icon={`https://tamtam.s3-eu-west-1.amazonaws.com/cdn/img/flags/${language.value}.png`}
              >
                <div className={styles.langTab}>
                  <label className={styles.configLabel}>
                    {_(`title_${language.value}`)}
                  </label>

                  <input
                    className={styles.formInput}
                    value={
                      portals.public.config.about[titleAttr(language.value)]
                    }
                    onChange={(e) =>
                      handlePortalBlocTitleChange(
                        language.value,
                        e.target.value,
                        "about"
                      )
                    }
                  />

                  <label
                    className={`${styles.configLabel} ${styles.descriptionLabel}`}
                  >
                    {_(`description_${language.value}`)}
                  </label>
                  <textarea
                    rows="4"
                    className={styles.descriptionInput}
                    value={
                      portals.public.config.about[
                        descriptionAttr(language.value)
                      ]
                    }
                    onChange={(e) =>
                      handlePortalBlocDescriptionChange(
                        language.value,
                        e.target.value,
                        "about"
                      )
                    }
                  />
                </div>
              </div>
            ))}
          </Tabs>
          <div
            className={styles.dropZone}
            style={{
              backgroundImage: `url(${
                aboutImage ? aboutImage.fullMediaUrl : ""
              })`,
            }}
            onClick={() => setAddMediaModalOpened(true)}
          >
            {!aboutImage && (
              <>
                <div className={styles.text}>
                  <span>{_("image_import_text")}</span>
                </div>
              </>
            )}
          </div>
          <AddSingleMedia
            isOpen={addMediaModalOpened}
            close={() => {
              setAddMediaModalOpened(false);
            }}
            token={auth.token}
            community={fiduciary}
            setImage={setAboutImage}
          />
        </>
      )}
    </div>
  );
};
export const SingleServiceAppPublic = ({
  handlePortalBlocChange,
  portals,
  singleServiceImage,
  setSingleServiceImage,
  titleAttr,
  handlePortalBlocTitleChange,
  descriptionAttr,
  handlePortalBlocDescriptionChange,
}) => {
  const auth = useSelector((state) => state.auth);
  const fiduciary = useSelector((state) => state.folder.fiduciary);
  const [addMediaModalOpened, setAddMediaModalOpened] = useState(false);

  return (
    <div className={styles.portalBloc}>
      <div className={styles.portalBloc_top}>
        <div className={styles.portalBloc_top_left}>
          <label>{_("Services")}</label>
        </div>
        <Switch
          isChecked={portals.public.config.singleService.activated}
          onChange={(e) => handlePortalBlocChange(e, "singleService")}
        />
      </div>
      {portals.public.config.singleService.activated && (
        <>
          <Tabs theme="wtheme">
            {languages.map((language) => (
              <div
                key={`langtab${language.value}`}
                label={language.label}
                icon={`https://tamtam.s3-eu-west-1.amazonaws.com/cdn/img/flags/${language.value}.png`}
              >
                <div className={styles.langTab}>
                  <label className={styles.configLabel}>
                    {_(`title_${language.value}`)}
                  </label>

                  <input
                    className={styles.formInput}
                    value={
                      portals.public.config.singleService[
                        titleAttr(language.value)
                      ]
                    }
                    onChange={(e) =>
                      handlePortalBlocTitleChange(
                        language.value,
                        e.target.value,
                        "singleService"
                      )
                    }
                  />

                  <label
                    className={`${styles.configLabel} ${styles.descriptionLabel}`}
                  >
                    {_(`description_${language.value}`)}
                  </label>
                  <textarea
                    rows="4"
                    className={styles.descriptionInput}
                    value={
                      portals.public.config.singleService[
                        descriptionAttr(language.value)
                      ]
                    }
                    onChange={(e) =>
                      handlePortalBlocDescriptionChange(
                        language.value,
                        e.target.value,
                        "singleService"
                      )
                    }
                  />
                </div>
              </div>
            ))}
          </Tabs>
          <div
            className={styles.dropZone}
            style={{
              backgroundImage: `url(${
                singleServiceImage ? singleServiceImage.fullMediaUrl : ""
              })`,
            }}
            onClick={() => setAddMediaModalOpened(true)}
          >
            {!singleServiceImage && (
              <>
                <div className={styles.text}>
                  <span>{_("image_import_text")}</span>
                </div>
              </>
            )}
          </div>
          <AddSingleMedia
            isOpen={addMediaModalOpened}
            close={() => {
              setAddMediaModalOpened(false);
            }}
            token={auth.token}
            community={fiduciary}
            setImage={setSingleServiceImage}
          />
        </>
      )}
    </div>
  );
};

export const NewsletterApp = ({ value, handleCheckApp, type }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <li className={classNames(styles.appsItem, styles.appsItem_header)}>
      <div className={styles.appsItem_topwatch}>
        <div className={styles.appsItem_top}>
          <DragHandle />
          <img src={`img/apps/${value.icon}`} alt="" />
          <span className={styles.watch}>
            <span>{value.name}</span>
          </span>
        </div>
        <span className={styles.watch_link} onClick={() => setIsOpen(true)}>
          {_("manage_newsletter_campaign")}
        </span>
      </div>

      <Switch
        isChecked={value.enabled}
        onChange={(e) => handleCheckApp(type, e, value)}
      />
      <NewsletterModal
        isOpen={isOpen}
        title={_("newsletter_preferences_title")}
        inProcess={false}
        setIsOpen={setIsOpen}
      />
    </li>
  );
};

const Checkbox = ({ checked, radio, onClick }) => {
  return (
    <div
      className={classNames(
        styles.checkbox,
        radio ? styles.radio : "",
        checked ? styles.checkbox_active : ""
      )}
      onClick={onClick}
    >
      {checked && (
        <svg
          width="10"
          height="10"
          viewBox="0 0 10 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_49976_35660)">
            <path
              d="M3.95836 9.44352C3.68037 9.44352 3.41746 9.31425 3.24844 9.09253L0.965733 6.09609C0.668833 5.70637 0.746124 5.15145 1.1382 4.85621C1.53092 4.56085 2.08882 4.63818 2.38584 5.02764L3.88721 6.99818L7.66322 0.971768C7.9232 0.557165 8.47216 0.430308 8.89017 0.68834C9.30767 0.946626 9.43517 1.49266 9.17506 1.90764L4.71441 9.02637C4.55945 9.27386 4.29193 9.42955 3.99899 9.44275C3.98532 9.44326 3.97191 9.44352 3.95836 9.44352Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_49976_35660">
              <rect
                width="8.94276"
                height="8.88889"
                fill="white"
                transform="translate(0.576172 0.554688)"
              />
            </clipPath>
          </defs>
        </svg>
      )}
    </div>
  );
};

export const SpecialtyAppPublic = ({
  handlePortalBlocChange,
  portals,
  setPortals,
  titleAttr,
  handlePortalBlocTitleChange,
  descriptionAttr,
  handlePortalBlocDescriptionChange,
  specialties,
  folderSpecialties,
  setFolderSpecialties,
  fiduciaryConfig,
}) => {
  const language = useSelector((state) => state.params.language);
  const nameAttr = `name${
    language.charAt(0).toUpperCase() + language.slice(1)
  }`;
  const [currentType, setCurrentType] = useState(null);

  useEffect(() => {
    if (!currentType && specialties)
      setCurrentType(specialties.filter((el) => el.isActivated)[0]);
  }, [specialties]);

  const allowAdd = ({ list }) => {
    const typeSpecialties = currentType.specialties
      .map((spec) => {
        return [
          spec.id,
          ...(spec.specialties ? spec.specialties.map((el) => el.id) : []),
        ];
      })
      .flat(1);

    const usedTypeSpecialties = list.filter((el) =>
      typeSpecialties.includes(el)
    );

    if (
      fiduciaryConfig.specialties.maxPicks !== -1 &&
      fiduciaryConfig.specialties.maxPicks < usedTypeSpecialties.length + 1
    ) {
      return false;
    }
    return true;
  };

  const handleCheckChange = ({ specialty, subSpecialty }) => {
    let list = folderSpecialties?.list;
    let favorites = folderSpecialties?.favorites;
    if (subSpecialty) {
      if (!specialty.isMultiSelect) {
        if (!list.includes(specialty.id)) {
          return null;
        }
        if (allowAdd({ list })) {
          list = list.filter(
            (el) => !specialty.specialties.map((em) => em.id).includes(el)
          );
          list.push(subSpecialty.id);
        }
      } else {
        if (list.includes(subSpecialty.id)) {
          list = list.filter((el) => el !== subSpecialty.id);
          if (favorites.includes(subSpecialty.id)) {
            favorites = favorites.filter((el) => el !== subSpecialty.id);
          }
        } else {
          if (allowAdd({ list })) {
            list.push(subSpecialty.id);
          }
        }
      }
    } else {
      if (allowAdd({ list })) {
        list = list.filter(
          (el) =>
            !currentType.specialties
              .map((spec) => {
                return [
                  spec.id,
                  ...(spec.specialties
                    ? spec.specialties.map((el) => el.id)
                    : []),
                ];
              })
              .flat(1)
              .includes(el)
        );
        list.push(specialty.id);
      }
    }

    setFolderSpecialties({ favorites, list });
  };

  const allowAddFavorite = ({ favorites }) => {
    const typeSpecialties = currentType.specialties
      .map((spec) => {
        return [
          spec.id,
          ...(spec.specialties ? spec.specialties.map((el) => el.id) : []),
        ];
      })
      .flat(1);

    const usedTypeSpecialties = favorites.filter((el) =>
      typeSpecialties.includes(el)
    );

    if (
      fiduciaryConfig.specialties.maxFavorites <
      usedTypeSpecialties.length + 1
    ) {
      return false;
    }
    return true;
  };

  const checkFavorite = (id, specialty) => {
    let favorites = folderSpecialties.favorites;
    let list = folderSpecialties.list;

    if (favorites.includes(id)) {
      favorites = favorites.filter((el) => el !== id);
    } else if (allowAddFavorite({ favorites })) {
      favorites.push(id);
      if (!list.includes(id)) {
        list.push(id);
      }
    }
    setFolderSpecialties({ list, favorites });
  };

  return (
    <div className={styles.portalBloc}>
      <div className={styles.portalBloc_top}>
        <div className={styles.portalBloc_top_left}>
          <img src={`img/apps/specialty.svg`} alt="" />
          <label>{_("Specialties")}</label>
        </div>
        <Switch
          name="specialty"
          isChecked={portals.public.config.specialty.activated}
          onChange={(e) => handlePortalBlocChange(e, "specialty")}
        />
      </div>
      {portals.public.config.specialty.activated && (
        <>
          <Tabs theme="wtheme">
            {languages.map((language) => (
              <div
                key={`langtab${language.value}`}
                label={language.label}
                icon={`https://tamtam.s3-eu-west-1.amazonaws.com/cdn/img/flags/${language.value}.png`}
              >
                <div className={styles.langTab}>
                  <label className={styles.configLabel}>
                    {_(`title_${language.value}`)}
                  </label>

                  <input
                    className={styles.formInput}
                    value={
                      portals.public.config.specialty[titleAttr(language.value)]
                    }
                    onChange={(e) =>
                      handlePortalBlocTitleChange(
                        language.value,
                        e.target.value,
                        "specialty"
                      )
                    }
                  />

                  <label
                    className={`${styles.configLabel} ${styles.descriptionLabel}`}
                  >
                    {_(`description_${language.value}`)}
                  </label>
                  <textarea
                    rows="4"
                    className={styles.descriptionInput}
                    value={
                      portals.public.config.specialty[
                        descriptionAttr(language.value)
                      ]
                    }
                    onChange={(e) =>
                      handlePortalBlocDescriptionChange(
                        language.value,
                        e.target.value,
                        "specialty"
                      )
                    }
                  />
                </div>
              </div>
            ))}
          </Tabs>
          {specialties && (
            <>
              <hr className={styles.separator} />
              <div className={styles.specialtyContent}>
                <h2 className={styles.title}>{_("Specialties")}</h2>
                <span className={styles.subtitle}>
                  {_("specialties_subtitle")}
                </span>
                <ul className={styles.typesList}>
                  {specialties.map((type) => {
                    if (!type.isActivated) return null;
                    return (
                      <li
                        className={
                          currentType && currentType.id === type.id
                            ? styles.active
                            : ""
                        }
                        onClick={() => setCurrentType(type)}
                      >
                        {type[nameAttr]}
                      </li>
                    );
                  })}
                </ul>
                {currentType && currentType.specialties && (
                  <div className="grid-x">
                    {currentType.specialties.map((specialty, i) => (
                      <div
                        className={classNames(
                          "cell small-4",
                          styles.specialty,
                          (i + 1) % 3 === 0 ? styles.noBorder : ""
                        )}
                      >
                        <div className={styles.title}>
                          {currentType.hasChoices && (
                            <Checkbox
                              checked={folderSpecialties?.list.includes(
                                specialty.id
                              )}
                              radio={true}
                              onClick={() => handleCheckChange({ specialty })}
                            />
                          )}
                          {specialty.icon && (
                            <i
                              className={`icon webtool-${specialty.icon.label}`}
                            />
                          )}
                          <span
                            className={styles.name}
                            onClick={() => {
                              if (currentType.hasChoices)
                                handleCheckChange({ specialty });
                            }}
                            style={{
                              cursor: currentType.hasChoices
                                ? "pointer"
                                : "default",
                            }}
                          >
                            {specialty[nameAttr]}
                          </span>
                        </div>
                        {specialty.specialties && (
                          <ul className={styles.specialtiesList}>
                            {specialty.specialties.map((subSpecialty) => (
                              <li
                                className={styles.subSpec}
                                style={{
                                  opacity:
                                    !specialty.isMultiSelect &&
                                    !folderSpecialties?.list.includes(
                                      specialty.id
                                    )
                                      ? "0.5"
                                      : "1",
                                }}
                              >
                                <Checkbox
                                  checked={folderSpecialties?.list.includes(
                                    subSpecialty.id
                                  )}
                                  radio={!specialty.isMultiSelect}
                                  onClick={() =>
                                    handleCheckChange({
                                      subSpecialty,
                                      specialty,
                                    })
                                  }
                                />
                                <span
                                  onClick={() =>
                                    handleCheckChange({
                                      subSpecialty,
                                      specialty,
                                    })
                                  }
                                >
                                  {subSpecialty[nameAttr]}
                                </span>
                                {specialty.isMultiSelect &&
                                  fiduciaryConfig.specialties
                                    .allowFavorites && (
                                    <IconStar
                                      className={classNames(
                                        styles.star,
                                        folderSpecialties?.favorites.includes(
                                          subSpecialty.id
                                        )
                                          ? styles.active
                                          : ""
                                      )}
                                      onClick={() =>
                                        checkFavorite(
                                          subSpecialty.id,
                                          specialty
                                        )
                                      }
                                      filled={folderSpecialties?.favorites.includes(
                                        subSpecialty.id
                                      )}
                                    />
                                  )}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export const TeamAppPublic = ({
  handlePortalBlocChange,
  portals,
  titleAttr,
  handlePortalBlocTitleChange,
  descriptionAttr,
  handlePortalBlocDescriptionChange,
  sortCollaborators,
  collaborators,
  setCollaborators,
}) => {
  return (
    <div className={styles.portalBloc}>
      <div className={styles.portalBloc_top}>
        <div className={styles.portalBloc_top_left}>
          <img src={`img/apps/team.svg`} alt="" />
          <label>{_("Team")}</label>
        </div>
        <Switch
          name="team"
          isChecked={portals.public.config.team.activated}
          onChange={(e) => handlePortalBlocChange(e, "team")}
        />
      </div>
      {portals.public.config.team.activated && (
        <>
          <Tabs theme="wtheme">
            {languages.map((language) => (
              <div
                key={`langtab${language.value}`}
                label={language.label}
                icon={`https://tamtam.s3-eu-west-1.amazonaws.com/cdn/img/flags/${language.value}.png`}
              >
                <div className={styles.langTab}>
                  <label className={styles.configLabel}>
                    {_(`title_${language.value}`)}
                  </label>

                  <input
                    className={styles.formInput}
                    value={
                      portals.public.config.team[titleAttr(language.value)]
                    }
                    onChange={(e) =>
                      handlePortalBlocTitleChange(
                        language.value,
                        e.target.value,
                        "team"
                      )
                    }
                  />

                  <label
                    className={`${styles.configLabel} ${styles.descriptionLabel}`}
                  >
                    {_(`description_${language.value}`)}
                  </label>
                  <textarea
                    rows="4"
                    className={styles.descriptionInput}
                    value={
                      portals.public.config.team[
                        descriptionAttr(language.value)
                      ]
                    }
                    onChange={(e) =>
                      handlePortalBlocDescriptionChange(
                        language.value,
                        e.target.value,
                        "team"
                      )
                    }
                  />
                </div>
              </div>
            ))}
          </Tabs>
          <div className={styles.services}>
            <CollaboratorsSortableList
              onSortEnd={(e) => sortCollaborators(e)}
              axis={"xy"}
              collaborators={collaborators}
              setCollaborators={setCollaborators}
              distance={1}
            />
          </div>
        </>
      )}
    </div>
  );
};

export const ContactAppPublic = ({
  handlePortalBlocChange,
  portals,
  handleGeoChange,
  addPushPinOnClick,
  handleChangeSchedule,
  handleApplySchedule,
  contactEmailError,
  setContactEmailError,
  contactPhoneError,
  setContactPhoneError,
}) => {
  const renderTime = (val) => {
    return ["00:00", "", "__:__", "NO_WORK"].includes(val)
      ? val
      : val.replace(/_/g, "0");
  };
  return (
    <div className={styles.portalBloc}>
      <div className={styles.portalBloc_top}>
        <div className={styles.portalBloc_top_left}>
          <img src={`img/apps/ebox.svg`} alt="" />
          <label>{_("Contact")}</label>
        </div>
        <Switch
          isChecked={portals.public.config.contact.activated}
          onChange={(e) => handlePortalBlocChange(e, "contact")}
        />
      </div>

      {portals.public.config.contact.activated && (
        <>
          <div className="grid-x grid-margin-x">
            <div className="cell small-12 medium-6">
              <FormInput
                name="email"
                value={portals.public.config.contact.email}
                label={_("Email")}
                autoComplete="none"
                onChange={(e) => handleGeoChange(e, "email")}
                handleBlur={(e) => {
                  if (
                    e.target.value.length > 0 &&
                    !validateEmail(e.target.value)
                  ) {
                    setContactEmailError(_("validate_email"));
                  } else {
                    setContactEmailError();
                  }
                }}
                error={contactEmailError}
              />
            </div>

            <div className="cell small-12 medium-6">
              <FormInput
                name="phone"
                value={portals.public.config.contact.phone}
                label={_("phone_number")}
                autoComplete="none"
                onChange={(e) => handleGeoChange(e, "phone")}
                handleBlur={(e) => {
                  if (
                    e.target.value.length > 0 &&
                    !validatePhone(e.target.value).valid
                  ) {
                    setContactPhoneError(_("validate_phone"));
                  } else {
                    setContactPhoneError("");
                  }
                }}
                error={contactPhoneError}
              />
            </div>
          </div>

          <div className="grid-x grid-margin-x">
            <div className="cell small-12 medium-6">
              <FormInput
                name="latitude"
                value={portals.public.config.contact.latitude}
                label={_("Latitude")}
                autoComplete="none"
                onChange={(e) => handleGeoChange(e, "latitude")}
              />
            </div>

            <div className="cell small-12 medium-6">
              <FormInput
                name="longitude"
                value={portals.public.config.contact.longitude}
                label={_("Longitude")}
                autoComplete="none"
                onChange={(e) => handleGeoChange(e, "longitude")}
              />
            </div>
          </div>

          <div className={styles.mapbox}>
            <ReactBingmaps
              bingmapKey="AlfqRT9EH4KtKEzZQp4yhxAIWxiujabG1jpSuUJaQ_GWxN9ONI_MQvd_e2kJpK5H"
              zoom={14}
              mapTypeId={"aerial"}
              mapOptions={{ disableScrollWheelZoom: true }}
              center={[
                parseFloat(portals.public.config.contact.latitude),
                parseFloat(portals.public.config.contact.longitude),
              ]}
              navigationBarMode={"compact"}
              getLocation={{
                addHandler: "click",
                callback: addPushPinOnClick,
              }}
              pushPins={[
                {
                  location: [
                    parseFloat(portals.public.config.contact.latitude),
                    parseFloat(portals.public.config.contact.longitude),
                  ],
                  option: {
                    color: "#18A0FB",
                    icon: "https://unpkg.com/leaflet@1.3.3/dist/images/marker-icon.png",
                  },
                },
              ]}
            />
          </div>

          <div className={styles.schedule}>
            <div className={styles.schedule_row}>
              <div
                className={`${styles.schedule_header} ${styles.schedule_day}`}
              >
                {_("Day")}
              </div>
              <div
                className={`${styles.schedule_header} ${styles.schedule_hours}`}
              >
                {_("Morning")}
              </div>
              <div
                className={`${styles.schedule_header} ${styles.schedule_hours}`}
              >
                {_("Afternoon")}
              </div>
              <div className={`${styles.schedule_action}`}> </div>
            </div>
            {days.map((day) => {
              return (
                <div className={styles.schedule_row} key={`day${day}`}>
                  <div className={`${styles.schedule_day}`}>{_(`${day}`)}</div>
                  <div className={`${styles.schedule_hours}`}>
                    <div className={styles.schedule_input}>
                      <TimeInput
                        value={renderTime(
                          portals.public.config.contact.schedule[day].MORNING
                            .FROM
                        )}
                        onChange={(e) =>
                          handleChangeSchedule(
                            e.target.value,
                            day,
                            "MORNING",
                            "FROM"
                          )
                        }
                      />
                      <span>{_("to")}</span>
                      <TimeInput
                        value={renderTime(
                          portals.public.config.contact.schedule[day].MORNING.TO
                        )}
                        onChange={(e) =>
                          handleChangeSchedule(
                            e.target.value,
                            day,
                            "MORNING",
                            "TO"
                          )
                        }
                      />
                    </div>
                    <div className={styles.schedule_nowork}>
                      <Switch
                        isChecked={
                          portals.public.config.contact.schedule[day].MORNING
                            .FROM === "NO_WORK"
                        }
                        onChange={() =>
                          handleChangeSchedule(
                            "NO_WORK",
                            day,
                            "MORNING",
                            "FROM"
                          )
                        }
                      />
                      <span>{_("No work")}</span>
                    </div>
                  </div>
                  <div className={`${styles.schedule_hours}`}>
                    <div className={styles.schedule_input}>
                      <TimeInput
                        value={renderTime(
                          portals.public.config.contact.schedule[day].AFTERNOON
                            .FROM
                        )}
                        onChange={(e) =>
                          handleChangeSchedule(
                            e.target.value,
                            day,
                            "AFTERNOON",
                            "FROM"
                          )
                        }
                      />
                      <span>{_("to")}</span>
                      <TimeInput
                        value={renderTime(
                          portals.public.config.contact.schedule[day].AFTERNOON
                            .TO
                        )}
                        onChange={(e) =>
                          handleChangeSchedule(
                            e.target.value,
                            day,
                            "AFTERNOON",
                            "TO"
                          )
                        }
                      />
                    </div>
                    <div className={styles.schedule_nowork}>
                      <Switch
                        isChecked={
                          portals.public.config.contact.schedule[day].AFTERNOON
                            .FROM === "NO_WORK"
                        }
                        onChange={() =>
                          handleChangeSchedule(
                            "NO_WORK",
                            day,
                            "AFTERNOON",
                            "FROM"
                          )
                        }
                      />
                      <span>{_("No work")}</span>
                    </div>
                  </div>
                  <div className={`${styles.schedule_action}`}>
                    {day === "MON" && (
                      <span
                        className={styles.schedule_btn}
                        onClick={handleApplySchedule}
                      >
                        {_("Apply_for_all_days")}
                      </span>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};

export const ServicesAppPublic = ({
  handlePortalBlocChange,
  portals,
  descriptionAttr,
  handlePortalBlocDescriptionChange,
  services,
  setServices,
  sortServices,
  fiduciaryConfig,
}) => {
  const token = useSelector((state) => state.auth.token);
  const [openServiceModal, setOpenServiceModal] = useState(false);
  const [currentService, setCurrentService] = useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(null);
  const [serviceToDelete, setServiceToDelete] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const afterServiceSave = (val) => {
    if (services.map((el) => el.id).includes(val.id)) {
      setServices(
        services.map((el) => {
          if (el.id === val.id) {
            return val;
          }
          return el;
        })
      );
    } else {
      setServices([val, ...services]);
    }
  };

  const onDelete = (val) => {
    setServiceToDelete(val);
    setDeleteModalOpen(true);
  };
  const onEdit = (val) => {
    setCurrentService(val);
    setOpenServiceModal(true);
  };

  const allowAdd = () => {
    if (fiduciaryConfig.services.maxPicks === -1) {
      return true;
    }
    return !(
      fiduciaryConfig.services.maxPicks <
      services.filter((el) => el.show).length + 1
    );
  };

  const onHide = (val) => {
    setServices(
      services.map((el) => {
        if (el.id === val.id) {
          return el.show || (!el.show && allowAdd())
            ? { ...el, show: !el.show }
            : el;
        }
        return el;
      })
    );
  };

  const serviceDelete = async () => {
    try {
      setDeleting(true);
      await deleteService(token, serviceToDelete.id);
      setServices(services.filter((el) => el.id !== serviceToDelete.id));
      setServiceToDelete(null);
      setDeleting(false);
      setDeleteModalOpen(false);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className={styles.portalBloc}>
      <div className={styles.portalBloc_top}>
        <div className={styles.portalBloc_top_left}>
          <label>{_("Services")}</label>
        </div>
        <Switch
          isChecked={portals.public.config.services.activated}
          onChange={(e) => handlePortalBlocChange(e, "services")}
        />
      </div>
      {portals.public.config.services.activated && (
        <>
          <Tabs theme="wtheme">
            {languages.map((language) => (
              <div
                key={`langtab${language.value}`}
                label={language.label}
                icon={`https://tamtam.s3-eu-west-1.amazonaws.com/cdn/img/flags/${language.value}.png`}
              >
                <div className={styles.langTab}>
                  <label className={`${styles.configLabel}`}>
                    {_(`description_${language.value}`)}
                  </label>
                  <textarea
                    rows="4"
                    className={styles.descriptionInput}
                    value={
                      portals.public.config.services[
                        descriptionAttr(language.value)
                      ]
                    }
                    onChange={(e) =>
                      handlePortalBlocDescriptionChange(
                        language.value,
                        e.target.value,
                        "services"
                      )
                    }
                  />
                </div>
              </div>
            ))}
          </Tabs>
          <Button
            className={styles.addMedia}
            size={"sm"}
            onClick={() => setOpenServiceModal(true)}
          >
            {_("add_service")}
          </Button>
          <ServicesSortableList
            services={services}
            onDelete={onDelete}
            onEdit={onEdit}
            onHide={onHide}
            axis={"xy"}
            distance={1}
            onSortEnd={(e) => sortServices(e)}
          />

          <ModalConfirm
            type="delete"
            isOpen={deleteModalOpen}
            onCancel={() => setDeleteModalOpen(false)}
            onConfirm={serviceDelete}
            inProcess={deleting}
            title={_("delete_confirm")}
            text={_("text_delete_collaborator")}
            labelNo={_("no")}
            labelYes={_("yes")}
          />

          <ServicePopOver
            languages={languages}
            isOpen={openServiceModal}
            onClose={() => setOpenServiceModal(false)}
            afterServiceSave={afterServiceSave}
            currentElement={currentService}
            setCurrentElement={setCurrentService}
          />
        </>
      )}
    </div>
  );
};

export const FaqsAppPublic = ({
  handlePortalBlocChange,
  portals,
  descriptionAttr,
  handlePortalBlocDescriptionChange,
  faqs,
  setFaqs,
  sortFaqs,
  fiduciaryConfig,
}) => {
  const token = useSelector((state) => state.auth.token);
  const [openModal, setOpenModal] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(null);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const afterSave = (val) => {
    if (faqs.map((el) => el.id).includes(val.id)) {
      setFaqs(
        faqs.map((el) => {
          if (el.id === val.id) {
            return val;
          }
          return el;
        })
      );
    } else {
      setFaqs([val, ...faqs]);
    }
  };

  const onDelete = (val) => {
    setItemToDelete(val);
    setDeleteModalOpen(true);
  };
  const onEdit = (val) => {
    setCurrentItem(val);
    setOpenModal(true);
  };

  const allowAdd = () => {
    if (fiduciaryConfig.faq.maxPicks === -1) {
      return true;
    }
    return !(
      fiduciaryConfig.faq.maxPicks <
      faqs.filter((el) => el.show).length + 1
    );
  };

  const onHide = (val) => {
    setFaqs(
      faqs.map((el) => {
        if (el.id === val.id) {
          return el.show || (!el.show && allowAdd())
            ? { ...el, show: !el.show }
            : el;
        }
        return el;
      })
    );
  };

  const faqDelete = async () => {
    try {
      setDeleting(true);
      await deleteFaq(token, itemToDelete.id);
      setFaqs(faqs.filter((el) => el.id !== itemToDelete.id));
      setItemToDelete(null);
      setDeleting(false);
      setDeleteModalOpen(false);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className={styles.portalBloc}>
      <div className={styles.portalBloc_top}>
        <div className={styles.portalBloc_top_left}>
          <label>{_("Faq")}</label>
        </div>
        <Switch
          isChecked={portals.public.config.faqs.activated}
          onChange={(e) => handlePortalBlocChange(e, "faqs")}
        />
      </div>
      {portals.public.config.faqs.activated && (
        <>
          <Tabs theme="wtheme">
            {languages.map((language) => (
              <div
                key={`langtab${language.value}`}
                label={language.label}
                icon={`https://tamtam.s3-eu-west-1.amazonaws.com/cdn/img/flags/${language.value}.png`}
              >
                <div className={styles.langTab}>
                  <label className={`${styles.configLabel}`}>
                    {_(`description_${language.value}`)}
                  </label>
                  <textarea
                    rows="4"
                    className={styles.descriptionInput}
                    value={
                      portals.public.config.faqs[
                        descriptionAttr(language.value)
                      ]
                    }
                    onChange={(e) =>
                      handlePortalBlocDescriptionChange(
                        language.value,
                        e.target.value,
                        "faqs"
                      )
                    }
                  />
                </div>
              </div>
            ))}
          </Tabs>
          <Button
            className={styles.addMedia}
            size={"sm"}
            onClick={() => setOpenModal(true)}
          >
            {_("add_faq")}
          </Button>

          <FaqsSortableList
            faqs={faqs}
            onDelete={onDelete}
            onEdit={onEdit}
            onHide={onHide}
            distance={1}
            onSortEnd={(e) => sortFaqs(e)}
          />

          <ModalConfirm
            type="delete"
            isOpen={deleteModalOpen}
            onCancel={() => setDeleteModalOpen(false)}
            onConfirm={faqDelete}
            inProcess={deleting}
            title={_("delete_confirm")}
            text={_("text_delete_collaborator")}
            labelNo={_("no")}
            labelYes={_("yes")}
          />

          <FaqModal
            languages={languages}
            isOpen={openModal}
            onClose={() => setOpenModal(false)}
            afterSave={afterSave}
            currentElement={currentItem}
            setCurrentElement={setCurrentItem}
          />
        </>
      )}
    </div>
  );
};

export const TestimonialsAppPublic = ({
  handlePortalBlocChange,
  portals,
  testimonials,
  setTestimonials,
  sortTestimonials,
  fiduciaryConfig,
}) => {
  const token = useSelector((state) => state.auth.token);
  const [openModal, setOpenModal] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(null);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const afterSave = (val) => {
    if (testimonials.map((el) => el.id).includes(val.id)) {
      setTestimonials(
        testimonials.map((el) => {
          if (el.id === val.id) {
            return val;
          }
          return el;
        })
      );
    } else {
      setTestimonials([val, ...testimonials]);
    }
  };

  const onDelete = (val) => {
    setItemToDelete(val);
    setDeleteModalOpen(true);
  };
  const onEdit = (val) => {
    setCurrentItem(val);
    setOpenModal(true);
  };

  const allowAdd = () => {
    if (fiduciaryConfig.testimonials.maxPicks === -1) {
      return true;
    }
    return !(
      fiduciaryConfig.testimonials.maxPicks <
      testimonials.filter((el) => el.show).length + 1
    );
  };

  const onHide = (val) => {
    setTestimonials(
      testimonials.map((el) => {
        if (el.id === val.id) {
          return el.show || (!el.show && allowAdd())
            ? { ...el, show: !el.show }
            : el;
        }
        return el;
      })
    );
  };

  const testimonialDelete = async () => {
    try {
      setDeleting(true);
      await deleteTestimonial(token, itemToDelete.id);
      setTestimonials(testimonials.filter((el) => el.id !== itemToDelete.id));
      setItemToDelete(null);
      setDeleting(false);
      setDeleteModalOpen(false);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className={styles.portalBloc}>
      <div className={styles.portalBloc_top}>
        <div className={styles.portalBloc_top_left}>
          <label>{_("testimonials")}</label>
        </div>
        <Switch
          isChecked={portals.public.config.testimonials.activated}
          onChange={(e) => handlePortalBlocChange(e, "testimonials")}
        />
      </div>
      {portals.public.config.testimonials.activated && (
        <div className={styles.testimonial_content}>
          <Button
            className={styles.addMedia}
            size={"sm"}
            onClick={() => setOpenModal(true)}
          >
            {_("add_testimonial")}
          </Button>
          <TestimonialsSortableList
            testimonials={testimonials}
            onDelete={onDelete}
            onEdit={onEdit}
            onHide={onHide}
            distance={1}
            onSortEnd={(e) => sortTestimonials(e)}
          />

          <ModalConfirm
            type="delete"
            isOpen={deleteModalOpen}
            onCancel={() => setDeleteModalOpen(false)}
            onConfirm={testimonialDelete}
            inProcess={deleting}
            title={_("delete_confirm")}
            text={_("text_delete_collaborator")}
            labelNo={_("no")}
            labelYes={_("yes")}
          />

          <TestimonialModal
            languages={languages}
            isOpen={openModal}
            onClose={() => setOpenModal(false)}
            afterSave={afterSave}
            currentElement={currentItem}
            setCurrentElement={setCurrentItem}
          />
        </div>
      )}
    </div>
  );
};
